<template>
  <dara-modal
    ref="modal"
    :title="$t('warning')"
    v-bind="$attrs"
    v-on="$listeners">
    <template #content>
      <div v-if="content !== null">
        {{ content }}
      </div>
      <div v-else>
        {{ $t('are-you-sure-you-want-to-delete-this-item') }}
      </div>
    </template>
    <template #footer>
      <dara-button
        class="btn btn-danger"
        size="sm"
        @click="confirm()">
        {{ $t('delete') }}
      </dara-button>
    </template>
  </dara-modal>
</template>

<script>
export default {
  name: 'DaraModalConfirm',
  props: {
    closeAfterConfirm: {
      type: Boolean,
      default: true,
    },
    content: {
      type: String,
      default: null,
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm');
      if (this.closeAfterConfirm) {
        this.$refs.modal.close();
      }
    },
  },
};
</script>
